export const measureColors: { [key: string]: string } = {
    ppt: "#d0d0ff",
    //ppt: '#c0c0ff',
    // ppt: '#BE9EDD',
    // pptLabel: '#333333',
    // ws: '#889288',
    // tmax: '#e84749',
    // tmin: '#2828aa',
    // sst: '#66bbdd',
    // wet: '#559966',
    // sunhrs: '#eec822',
    // dayhrs: '#dd8822',
    // rhm: '#bb8822',
    //ppt: '#BE9EDD',
    pptLabel: "#333333",
    ws: "#73786B",
    tmax: "#E84749",
    tmin: "#2351B8",
    sst: "#49B3EE",
    wet: "#69A770",
    sunhrs: "#E5B803",
    dayhrs: "#E27113",
    rhm: "#A37656"
};
